/**
 * Labstep
 *
 * @module state/reducers/params
 * @desc Reducer to hold url get params that could be user later in the app (e.g. referral code)
 */

import type { AnyAction } from 'redux';

export type StateParams = Record<string, unknown>;

const urlParamsReducer = (
  state: StateParams = {},
  action: AnyAction,
) => {
  switch (action.type) {
    case 'SET_PARAMS':
      return action.params;
    case 'CLEAR_PARAMS':
      return {};
    default:
      return state;
  }
};

export default urlParamsReducer;
